import { render } from "./table-item.vue?vue&type=template&id=e8a30166&scoped=true&ts=true"
import script from "./table-item.vue?vue&type=script&lang=ts"
export * from "./table-item.vue?vue&type=script&lang=ts"

import "./table-item.vue?vue&type=style&index=0&id=e8a30166&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8a30166"]])

export default __exports__